/* The quantity stepper.
 *
 * ksg.pdp.increase and ksg.pdp.decrease have been sitting in both locale
 * files since the beginning with nothing rendering them - the design asked
 * for a stepper and what got built was a bare number field. On a phone that
 * means tapping a small target, waiting for a numeric keyboard, typing, and
 * dismissing it, to go from one to two. Every marketplace this design is
 * measured against uses minus and plus for the same reason.
 *
 * The buttons are built here rather than rendered in Liquid so that a page
 * without JavaScript gets the plain field, which works, instead of two
 * controls that do nothing.
 */

const clamp = (input) => {
  const min = Number(input.min) || 1;
  const max = input.max === '' ? Infinity : Number(input.max);
  const value = Number(input.value) || min;
  return Math.min(Math.max(value, min), max);
};

document.querySelectorAll('[data-ksg-qty]').forEach((wrap) => {
  const input = wrap.querySelector('input[name="quantity"]');
  if (!input) return;

  const step = (delta) => {
    input.value = String(clamp({ min: input.min, max: input.max, value: (Number(input.value) || 1) + delta }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync();
  };

  const button = (delta, label) => {
    const el = document.createElement('button');
    el.type = 'button'; /* never submits the form it sits in */
    el.className = 'ksg-qty__step';
    el.textContent = delta < 0 ? '\u2212' : '+';
    el.setAttribute('aria-label', label || '');
    el.addEventListener('click', () => step(delta));
    return el;
  };

  const down = button(-1, wrap.dataset.labelDown);
  const up = button(1, wrap.dataset.labelUp);

  /* One live region per stepper, announced politely so a screen reader hears
     the ceiling without being interrupted mid-word. */
  const note = document.createElement('span');
  note.className = 'ksg-qty__limit';
  note.setAttribute('role', 'status');
  note.hidden = true;

  const sync = () => {
    const min = Number(input.min) || 1;
    const max = input.max === '' ? Infinity : Number(input.max);
    const now = clamp(input);
    down.disabled = now <= min;
    up.disabled = now >= max;

    /* The explanation goes with the disabling, not with a click on the
       disabled button - that click never arrives, because a disabled button
       emits no events. Written the other way round the message was
       unreachable: the plus switched itself off at the ceiling and then
       waited for a press that could not happen.

       So the moment the ceiling is reached, whether by pressing plus or by
       typing 99 into the field, the line says how many there actually are.
       A button that has quietly stopped responding reads as broken; one
       that stops beside "only 32 available" reads as an answer. */
    const atCeiling = now >= max && wrap.dataset.limit;
    note.textContent = atCeiling ? wrap.dataset.limit : '';
    note.hidden = !atCeiling;
  };

  input.before(down);
  input.after(up);
  wrap.after(note);

  input.addEventListener('change', () => {
    input.value = String(clamp(input));
    sync();
  });

  sync();
});
